<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.category == null ? data.sysText.addDocCategory_header : data.sysText.editDocCategory_header }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      (click)="cancel()"
      [attr.aria-label]="data.sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      [control]="form.controls.categoryName"
      [icon]="'subject'"
      [label]="data.sysText.categoryName"
      [inputType]="'string'"
        [hint]="data.category?.isSystem == true ? data.sysText.systemCategoryNameMessage : 
        this.data?.category?.isStock == true ? data.sysText.stockCategoryNameMessage : ''"
    ></app-input-field>
    @if (data.dialogData.showOwner) {
      <div>
        @if (this.data.dialogData.canChangeOwner) {
          <app-select-field
            [control]="form.controls.ownerEmployerId"
            [label]="data.sysText.owner"
            [options]="data.dialogData.employers"
            [icon]="'business'"
            [shouldCapitalize]="false"
          ></app-select-field>
        } @else {
          <app-input-field
            [control]="form.controls.ownerEmployerId"
            [label]="data.sysText.owner"
            [icon]="'business'"
          [hint]="data.category?.isSystem == true ? data.sysText.systemCategoryOwnerMessage : 
          this.data?.category?.isStock == true ? data.sysText.stockCategoryOwnerMessage :
            data.dialogData.inUse ? data.sysText.inUseOwnerMessage : ''"
          ></app-input-field>
        }
      </div>
    }
    <app-slide-toggle
      [control]="form.controls.allowUse"
      [label]="data.sysText.allowUseMessage">
    </app-slide-toggle>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{ data.category == null ? data.sysText.add : data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>
